
import Vue from 'vue'
import ArrowBackIcon from '@/assets/svgs/arrow_back.svg?inline'

export default Vue.extend({
  name: 'BackLink',
  components: {
    ArrowBackIcon
  },
  props: {
    linkText: {
      type: String,
      required: false,
      default: function () {
        return this.$t('back')
      },
    },
  },
})
